import BaseClass from "../BaseClass";

export default class InputVisibilityControl extends BaseClass {
    constructor(element) {
        super(element);


        this.initInput();
        this.initListeners();
        this.onChange();

    }

    initInput() {
        const inputSelector = this.$element.data('input-selector');

        this.$input = $(inputSelector);

        this.$input.on('change', $.proxy(this.onChange, this));
    }

    initListeners() {
        this.$element.on('input-visibility-control:reload', $.proxy(this.onInputVisibilityControlReload, this));
    }


    onChange() {
        const val = this.$input.filter(':not(:disabled)').filter(':not([type="radio"], [type="checkbox"]), :checked').val();

        let valSet;
        switch (typeof val) {
            case 'undefined':
                valSet = false;
                break;
            case 'string':
                valSet = val.trim().length > 0;
                break;
            default:
                valSet = true;
        }

        const onSet = this.$element.data('input-val-set');
        const onUnset = this.$element.data('input-val-unset');

        let showVals = this.$element.data('input-val-show');
        if (typeof showVals != 'undefined' && !Array.isArray(showVals)) {
            showVals = [showVals];
        }

        let hideVals = this.$element.data('input-val-hide');
        if (typeof hideVals != 'undefined' && !Array.isArray(hideVals)) {
            hideVals = [hideVals];
        }

        let initial;
        if (['show', 'hide'].includes(onSet) && valSet) {
            initial = onSet;

        }
        if (['show', 'hide'].includes(onUnset) && !valSet) {
            initial = onUnset;
        }

        if (typeof initial == 'undefined') {
            switch (true) {
                case typeof showVals != 'undefined' && typeof hideVals != 'undefined':
                    break;
                case typeof showVals != 'undefined':
                    initial = 'hide';
                    break;
                case typeof hideVals != 'undefined':
                default:
                    initial = 'show';
            }
        }

        let show;
        switch (initial) {
            case 'show':
                show = true;
                break;
            case 'hide':
            default:
                show = false;
        }

        if (typeof showVals != 'undefined' && showVals.includes(val)) {
            show = true;
        }

        if (typeof hideVals != 'undefined' && hideVals.includes(val)) {
            show = false;
        }

        if (show) {
            this.$element.filter('.hidden').removeClass('hidden');
        } else {
            this.$element.filter(':not(.hidden)').addClass('hidden');
        }
    }

    onInputVisibilityControlReload() {
        this.teardownInput();
        this.initInput();
    }

    destroyListener() {
        this.teardownListeners();
        this.teardownInput();
    }

    teardownInput() {
        this.$input.off('change', $.proxy(this.onChange, this));

        delete this.$input;
    }

    teardownListeners() {
        this.$element.off('input-visibility-control:reload', $.proxy(this.onInputVisibilityControlReload, this));
    }
}